import { call, put, select, takeEvery } from "redux-saga/effects"
import { axiosPut, del, get, post } from "helpers/api_helper"
import { getFormDataFromJSON } from "utils"
import {
  showSavingModal,
  hideSavingModal,
  putMenuItemSuccess,
  setSelectedFeature,
  setIsOutdated,
} from "../actions"
import {
  addNewListFailed,
  addNewListSuccess,
  copyListFailed,
  copyListSuccess,
  deleteListItemFailed,
  deleteListItemSuccess,
  getExperiencesFailed,
  getExperiencesListFailed,
  getExperiencesListSuccess,
  getExperiencesSuccess,
  getListFeatureFailed,
  getListFeatureSuccess,
  getListItemClicksFailed,
  getListItemClicksSuccess,
  getListItemFailed,
  getListItemSuccess,
  getListOfListsFailed,
  getListOfListsSuccess,
  hideCopyListModal,
  hideDeleteListModal,
  updateListFailed,
  updateListFeatureFailed,
  updateListFeatureSuccess,
  updateListOrderFailed,
  updateListOrderSuccess,
  updateListSuccess,
} from "./actions"
import {
  ADD_NEW_LIST,
  COPY_LIST,
  DELETE_LIST_ITEM,
  GET_EXPERIENCES,
  GET_EXPERIENCES_LIST,
  GET_LIST_FEATURE,
  GET_LIST_ITEM,
  GET_LIST_ITEM_CLICKS,
  GET_LIST_OF_LISTS,
  UPDATE_LIST,
  UPDATE_LIST_FEATURE,
  UPDATE_LIST_ORDER,
} from "./actionTypes"

function* addNewList({ payload: params }) {
  try {
    yield put(showSavingModal())
    const list_items_response = []
    for (let item of params.listItems) {
      const preparedItem = item?.links
        ? { ...item, links: item.links.map(x => JSON.stringify(x)) }
        : item
      const response = yield post(
        "/list-item",
        getFormDataFromJSON(preparedItem)
      )
      list_items_response.push(response)
    }
    const list_feature_response = yield post("/list", {
      ...params.listFeature,
      list_items: list_items_response.map(item => item.id),
    })
    if (params.listFeature.menu_feature === 1) {
      const menuItem = yield axiosPut("/admin/menu-item", {
        entity_id: list_feature_response.id,
        menu_item_id: list_feature_response.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItem))
      yield put(setSelectedFeature(menuItem))
    }
    yield put(addNewListSuccess(list_feature_response))
    yield put(setIsOutdated(true))
    yield put(hideSavingModal())
  } catch (error) {
    yield put(addNewListFailed(error))
  }
}

function* updateList({ payload: params }) {
  try {
    yield put(showSavingModal())
    const list_item_ids = []
    for (let item of params.updatedListItems) {
      const preparedItem = item?.links
        ? { ...item, links: item.links.map(x => JSON.stringify(x)) }
        : item
      const response = yield post(
        `/list-item/${item.id}`,
        getFormDataFromJSON(preparedItem)
      )
      list_item_ids.push(response.id)
    }
    for (let item of params.newListItems) {
      const preparedNewItem = item?.links
        ? { ...item, links: item.links.map(x => JSON.stringify(x)) }
        : item
      const newItemResponse = yield post(
        "/list-item",
        getFormDataFromJSON(preparedNewItem)
      )
      list_item_ids.push(newItemResponse.id)
    }
    const listResponse = yield axiosPut(
      `/list/${params.listFeature.id}`,
      {
        ...params.listFeature,
        list_items: list_item_ids,
      },
      { params: { menu_item_id: params.listFeature.menu_item_id } }
    )
    yield put(updateListSuccess(listResponse))
    yield call(getListFeature, { payload: params.listFeature.id })
    yield put(hideSavingModal())
  } catch (error) {
    yield put(updateListFailed(error))
  }
}

function* deleteListItem({ payload: params }) {
  try {
    const response = yield del(`/list/${params.listId}`, {
      menu_item_id: params.menu_item_id,
    })
    yield put(deleteListItemSuccess(response))
    yield put(hideDeleteListModal())
  } catch (error) {
    yield put(deleteListItemFailed(error))
  }
}

function* updateListFeature({ payload: params }) {
  try {
    const response = yield axiosPut(`/list/${params.id}`, params, {
      params: {
        menu_item_id: params.menu_item_id,
      },
    })
    yield put(setIsOutdated(true))
    yield put(updateListFeatureSuccess(response))
  } catch (error) {
    yield put(updateListFeatureFailed(error))
  }
}

function* getListOfLists({ payload: params }) {
  try {
    const response = yield get("/list", { params })
    const destroyed = yield select(state => state.List.listDestroyed)
    if (!destroyed) {
      yield put(getListOfListsSuccess(response))
    }
  } catch (error) {
    yield put(getListOfListsFailed(error))
  }
}

function* getExperiences({ payload: {} }) {
  try {
    const response = yield get("/admin/search/events")
    yield put(getExperiencesSuccess(response))
  } catch (error) {
    yield put(getExperiencesFailed(error))
  }
}

function* getExperiencesList({ payload: params }) {
  try {
    const response = yield get("/list", { params })
    yield put(getExperiencesListSuccess(response))
  } catch (error) {
    yield put(getExperiencesListFailed(error))
  }
}

function* getListFeature({ payload: params }) {
  try {
    const response = yield get(`/list/${params}`)
    const destroyed = yield select(state => state.List.destroyed)
    if (!destroyed) {
      yield put(getListFeatureSuccess(response))
    }
  } catch (error) {
    yield put(getListFeatureFailed(error))
  }
}

function* copyList({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post("/list/copy", params)
    if (params.list_items.length === 0 && params.menu_feature === 0) {
      const listResponse = yield get("/list", {
        params: {
          event_id: params.event_id,
          menu_item_id: params.menu_item_id,
        },
      })
      yield put(getListOfListsSuccess(listResponse))
    }
    if (params.list_items.length === 0 && params.menu_feature === 1) {
      const menuItemResponse = yield axiosPut("/admin/menu-item", {
        entity_id: response.id,
        menu_item_id: params.menu_item_id,
      })
      yield put(putMenuItemSuccess(menuItemResponse))
      yield put(setSelectedFeature(menuItemResponse))
      yield put(setIsOutdated(true))
    }
    yield put(copyListSuccess(response))
    yield put(hideSavingModal())
    yield put(hideCopyListModal())
  } catch (error) {
    yield put(copyListFailed(error))
  }
}

function* updateListOrder({ payload: params }) {
  try {
    const response = yield axiosPut(`/list/${params.id}`, params, {
      params: {
        menu_item_id: params.menu_item_id,
      },
    })
    yield put(updateListOrderSuccess(response))
  } catch (error) {
    yield put(updateListOrderFailed(error))
  }
}

function* getListItem({ payload: params }) {
  try {
    const response = yield get(`/list-item/${params?.id}`)
    yield put(getListItemSuccess(response))
  } catch (error) {
    yield put(getListItemFailed(error))
  }
}

function* getListItemClicks({ payload: params }) {
  try {
    const response = yield get(`/list-item/${params?.id}/clicks`, {
      params: { event_id: params?.eventId },
    })
    yield put(getListItemClicksSuccess(response))
  } catch (error) {
    yield put(getListItemClicksFailed(error))
  }
}

function* listSaga() {
  yield takeEvery(ADD_NEW_LIST, addNewList)
  yield takeEvery(GET_LIST_OF_LISTS, getListOfLists)
  yield takeEvery(GET_EXPERIENCES, getExperiences)
  yield takeEvery(GET_EXPERIENCES_LIST, getExperiencesList)
  yield takeEvery(GET_LIST_FEATURE, getListFeature)
  yield takeEvery(UPDATE_LIST, updateList)
  yield takeEvery(DELETE_LIST_ITEM, deleteListItem)
  yield takeEvery(UPDATE_LIST_FEATURE, updateListFeature)
  yield takeEvery(COPY_LIST, copyList)
  yield takeEvery(UPDATE_LIST_ORDER, updateListOrder)
  yield takeEvery(GET_LIST_ITEM, getListItem)
  yield takeEvery(GET_LIST_ITEM_CLICKS, getListItemClicks)
}

export default listSaga
